import './App.css';
import { Helmet } from "react-helmet";
import { useState, useCallback, useEffect } from 'react';
import { isMobile, isAndroid, isDesktop, isIOS } from 'react-device-detect';

import { ClientJS } from 'clientjs';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import GooglePlay from './Landing';
import Game from './Game';
import IOSPopup from './IOSPopup';
import AndroidLanding from './AndroidLanding/AndroidLanding';

const LOG_URL = "https://wn-client-log.slotsjoy.cc/log";

function encodeJsonToBase64(obj) {
  try {
    const str = JSON.stringify(obj);
    // 步骤：1. stringify 2. 编码 UTF-8 3. btoa 转换
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode('0x' + p1);
    }));
  } catch (error) {
    console.error("Base64 编码失败:", error);
    return "";
  }
};

function isChromeBrowser() {
  const ua = navigator.userAgent.toLowerCase();
  const isChrome = ua.indexOf('chrome') > -1;
  const nav = window.navigator;
  const hasCustomHeader = /Google Inc/.test(nav.vendor);
  const hasChromObj = window.chrome;
  return isChrome && hasCustomHeader && hasChromObj
}

function isGuestLoginUrl() {
  var host = window.location.host;
  // console.log("host: " + host);
  var guestlogin = host.includes("d29hnxc9z6usq4.cloudfront.net") || host.includes("vegasclub.cc");
  // console.log("guestlogin: " + guestlogin);
  return guestlogin
}

function isRunningInPWA() {
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
    return true;
  }
  return false;
}

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
}

function generateUUID() {
  if (crypto && crypto.randomUUID) {
    console.log("use crypto.randomUUID");
    return crypto.randomUUID();
  } else {
    console.log("use uuidv4");
    return uuidv4();
  }
}

function initArguments() {
  if (isIOS) {
    localStorage.setItem("operating_system", "ios")
  } else if (isAndroid) {
    localStorage.setItem("operating_system", "android")
  } else {
    localStorage.setItem("operating_system", "pc")
  }

  localStorage.setItem("log_url", LOG_URL)

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var pwa = urlParams.get('pwa')
  if (pwa == "1" || isRunningInPWA()) {
    localStorage.setItem("pwa", "1");
    var params = localStorage.getItem("params")
    if (params == null) {
      params = getCookie("params");
      if (params != null) {
        setCookie("params", params, 128);
      }
    }

    if (params == null) {
      localStorage.setItem("params", "{}");
    } else {
      var paramJson = JSON.parse(params)
      paramJson.pwa = "1"
      var jsonString = JSON.stringify(paramJson);
      localStorage.setItem("params", jsonString);
      if (paramJson.webUdid != null) {
        localStorage.setItem("web_uuid", paramJson.webUdid);
      }
    }
    console.log("pwa url");
    return;
  }

  var search = queryString.substring(1);
  if (search.length == 0) {
    console.log("empty params");
    localStorage.setItem("params", "{}");
  } else {
    var decodeSearch = decodeURI(search);
    var params = '{"' + decodeSearch.replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}';
    var paramJson = JSON.parse(params)

    if (!isGuestLoginUrl()) {
      try {
        const client = new ClientJS()
        const fingerPrint = client.getFingerprint()
        paramJson.fingerPrint = fingerPrint
        console.log("client fingerPrint: " + fingerPrint)
      } catch (error) {
        console.error(error)
      }

      var uuid = localStorage.getItem("web_uuid")
      if (uuid == null) {
        uuid = generateUUID();
        localStorage.setItem("web_uuid", uuid)
      }

      paramJson.webUdid = uuid
      paramJson.web_udid = uuid
      console.log("web uuid: " + uuid);
      params = JSON.stringify(paramJson)
    }

    console.log("params: " + params);
    localStorage.setItem("params", params)
    setCookie("params", params, 128);
    localStorage.setItem("paramsString", decodeSearch);
    setCookie("paramsString", decodeSearch, 128);
  }
}

function sendEventLog(eventName) {
  var localParams = new Map(Object.entries(JSON.parse(localStorage.getItem("params"))));

  var key = eventName + "_logged"
  var body = {};
  body["action"] = eventName;
  body["first"] = localStorage.getItem(key) == null;
  body["host"] = window.location.host;
  if (isMobile) {
    body["os"] = "pc";
  } else {
    body["os"] = isAndroid ? "android" : "ios";
  }

  localParams.forEach((value, key) => {
    body[key] = value;
  });

  var content = JSON.stringify(body)
  console.log("sendEventLog: " + content);
  var xhr = new XMLHttpRequest();
  xhr.open("POST", LOG_URL, true);
  xhr.setRequestHeader("Content-type", "application/json");
  xhr.send(content);

  localStorage.setItem(key, "1");
}

function App() {
  initArguments()
  var urlParams = new Map(Object.entries(JSON.parse(localStorage.getItem("params"))));
  var id = "655023419951738"

  function openGame() {
    const url = new URL(window.location.href);  // 获取当前页面的 URL 对象
    url.searchParams.delete("pwa");  // 删除指定参数
    // 使用 window.location.replace() 来跳转到新 URL
    window.location.replace(url.toString());  // 这将替换当前页面并更新 URL
  }

  const [isAndroidLanding, setAndroidLanding] = useState(false);
  const [isIOSLanding, setIsIOSPopupVisible] = useState(false);
  var pixelId = urlParams.get('pixelId')
  if (!pixelId) {
    localStorage.setItem("pixelId", "")
  } else {
    localStorage.setItem("pixelId", pixelId)
    id = pixelId
  }

  var way = urlParams.get('way')

  // let s = "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};"
  //   + "if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');"
  //   + "fbq('init', '" + id + "');fbq('track', 'PageView');"
  // let nos = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=' + id + '&ev=PageView&noscript=1"/>'

  // let tt = '!function (w, d, t) {w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};'
  //   + "ttq.load('" + id + "');ttq.page();}(window, document, 'ttq');"

  async function initSdk() {
    try {
      await window.TrackingSDK.init({
        debug: true, // [可选] 是否开启详细⽇志 (默认 false)
        env: 'dev' // [可选] 环境标识: 'prod' | 'dev' (默认 'prod')
      });
    } catch (error) {
      // 捕获异步过程中的错误
      console.error("发生错误:", error);
    }
  }

  function Head() {
    return <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="applcd e-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
      <meta http-equiv="Pragma" content="no-cache" />
      <meta http-equiv="Expires" content="0" />
      {/* <script>
        {way == "tt" ? tt : s}
      </script> */}
      {/* <script src="https://sdk.getslotswin.com/sdk/cm/spark-analytics-sdk.12291428.umd.js" async
        onLoad={() => {
          console.log("脚本加载并执行成功");
        }}></script> */}
      {/* <noscript>
        {nos}
      </noscript> */}
    </Helmet>
  }

  function addSdk() {
    const scriptId = 'spark-analytics-sdk';
    const scriptUrl = "https://sdk.getslotswin.com/sdk/cm/spark-analytics-sdk.umd.js";
    if (document.getElementById(scriptId))
      return;

    console.log("add sdk...");
    // 2. 创建标签
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = scriptUrl;

    script.onload = () => {
      console.log("sdk loaded");
      initSdk({ debug: true, env: 'test' }).then(() => {
        console.log("TrackingSDK initialized successfully");
        const attribution = window.TrackingSDK.getAttribution();
        localStorage.setItem("attribution", JSON.stringify(attribution));
        const attributionType = attribution.h5_state.startsWith("organic") ? "organic" : "non-organic";
        localStorage.setItem("attributionType", attributionType);
        // console.log("TrackingSDK Attribution: ", attributionType);
        const encryptedAttribution = window.TrackingSDK.getEncryptedAttribution();
        var qid = window.TrackingSDK.getQID()
        var uuid = window.TrackingSDK.getUUID()
        var basic = encodeJsonToBase64(window.TrackingSDK.getBasic());
        console.log("sparkDeviceId: ", uuid);
        const sparkParams = JSON.stringify({ sparkToken: encryptedAttribution.attribution_data, qid: qid, sparkDeviceId: uuid, sparkBasic: basic });
        console.log("spark: ", sparkParams);
        localStorage.setItem("sparkParams", sparkParams);
      }).catch(err => console.error(err));
    };

    document.head.appendChild(script);
  }

  var isLanding = JSON.parse(localStorage.getItem("params")).pwa == '0';
  useEffect(() => {
    if (isLanding) {
      if (isIOS) {
        setIsIOSPopupVisible(true);
      } else {
        setAndroidLanding(true);
      }
    }

    addSdk();
  });

  var pwa = urlParams.get('pwa')
  let pageShowAdded = false;
  if (!pageShowAdded) {
    pageShowAdded = true;
    if (isLanding) {
      if (isDesktop) {
        sendEventLog('open_pwa_desktop');
      } else if (isChromeBrowser()) {
        sendEventLog('open_pwa_chrome');
      } else if (pwa == "1" || isRunningInPWA()) {
        sendEventLog('pwa_open_inphone');
      }
    }
  }


  let pageHideAdded = false;
  if (!pageHideAdded && isLanding) {
    pageHideAdded = true;
    const onPageHide = (e) => {
      sendEventLog('close_pwa');
    }
    window.addEventListener('pagehide', onPageHide);
  }

  if (isGuestLoginUrl()) {
    try {
      const client = new ClientJS()
      const fingerPrint = client.getFingerprint()
      localStorage.setItem("web_uuid", fingerPrint)
      console.log("client fingerPrint: " + fingerPrint)
    } catch (error) {
      localStorage.setItem("web_uuid", "")
      console.error(error)
    }

    FingerprintJS.load()
      .then(fp => fp.get())
      .then(result => {
        const visitorId = result.visitorId
        localStorage.setItem("web_uuid", visitorId)
        console.log('visitorId: ', visitorId)
      })
      .catch(error => console.error(error))
  }
  return (
    <div>
      {Head()}
      {isIOSLanding && <IOSPopup onClose={() => openGame()} sendLog={sendEventLog} />}
      {isAndroidLanding && <AndroidLanding sendLog={sendEventLog} isChromeBrowser={isChromeBrowser} />}
      {!isAndroidLanding && !isIOSLanding && <Game />}
    </div>
  )
}

export default App;
